<template>
  <button
    class="btn"
    :disabled="disabled"
    :class="[
      $attrs.class,
      typeClasses,
      sizeClasses,
      wideClasses,
      variantClasses,
      withIconLeft ? 'btn-icon-left' : '',
      withIconRight ? 'btn-icon-right' : '',
      withDefaultSlot ? 'btn-default-slot' : '',
    ]"
  >
    <div v-if="withIconLeft" class="btn-icon">
      <slot name="icon"></slot>
    </div>
    <div v-if="withDefaultSlot" class="btn-text">
      <slot></slot>
    </div>
    <div v-if="withIconRight" class="btn-icon">
      <slot name="icon-right"></slot>
    </div>
  </button>
</template>

<script lang="ts">
export type ButtonSize = 'small' | 'medium' | 'large'
</script>

<script setup lang="ts">
import type { Buttontype } from '@/types'
import { computed, useSlots } from 'vue'
type Props = {
  type?: Buttontype
  variant?: 'outline' | 'filled'
  disabled?: boolean
  size?: ButtonSize
  wide?: boolean
}

const props = withDefaults(defineProps<Props>(), { type: 'default', size: 'medium', variant: 'filled' })

const slots = useSlots()

const withDefaultSlot = computed(() => slots.default)
const withIconLeft = computed(() => slots.icon)
const withIconRight = computed(() => slots['icon-right'])

const typeClasses = computed(() => {
  switch (props.type) {
    case 'primary':
      return 'btn-primary'
    case 'secondary':
      return 'btn-secondary'
    case 'link':
      return 'btn-link'
    case 'danger':
      return 'btn-danger'
    case 'highlight':
      return 'btn-highlight'
    default:
      return ''
  }
})

const sizeClasses = computed(() => {
  switch (props.size) {
    case 'small':
      return 'btn-small'
    case 'medium':
      return 'btn-medium'
    case 'large':
      return 'btn-large'
    default:
      return ''
  }
})

const wideClasses = computed(() => {
  return props.wide ? 'btn-wide' : ''
})

const variantClasses = computed(() => {
  return props.variant === 'outline' ? 'btn-outline' : ''
})
</script>
